import React, { useState } from "react";
import { Modal } from "./Modal";
import { ModalBodyBuy } from "../ModalBodyBuy";
import { ethers } from "ethers";
import { saleAbi } from "../../blockchain/saleAbi";
import { erc20Abi } from "../../blockchain/erc20Abi";
import { cornAbi } from "../../blockchain/cornAbi";
import { constants } from "../../blockchain/constants";
import { currencyById } from "../../blockchain/currencies";
import apiClient from "../../apiClient";
import { ModalBodySell } from "../ModalBodySell";
const SellModal = ({
  setModalIsOpen,
  item,
  styledWrapper,
  setPageLoading,
  setForceRefresh,
  refreshPage,
  balance,
}) => {
  const [inputPrice, setInputPrice] = useState("0");
  return (
    <Modal
      setModalIsOpen={setModalIsOpen}
      title="Sell"
      btnTitle="Sell now"
      childrenBody={
        <ModalBodySell
          item={item}
          balance={balance}
          onChangePrice={(event) => {
            setInputPrice(event.target.value);
          }}
        />
      }
      styledWrapper={styledWrapper}
      onClick={async function () {
        try {
		console.log("판매 try 시");
          const checkbox = document.getElementById("sellNowTerms");
          const escrowCheckbox = document.getElementById("escrowSellNowTerms");
          if (checkbox && !checkbox["checked"]) {
            alert("서비스 약관에 동의해주세요.");
            return;
          }
          // we must not render on sale
          if (item.saleStatus === "ON_SALE") {
            alert("이미 판매중 입니다.");
            return;
          }

          if (parseInt(inputPrice, 10) <= 0) {
            alert("올바른 가격을 입력해주세요.");
            return;
          }
          const ethereum = window["ethereum"];
          if (ethereum) {
            const provider = new ethers.providers.Web3Provider(ethereum);
            const signer = provider.getSigner();
            const signerAddress = await signer.getAddress();
            const saleContract = new ethers.Contract(
              constants.SALE,
              saleAbi,
              signer
            );
            if (signerAddress.toLocaleLowerCase() !== item.userAddress) {
              alert("본인 NFT가 아닙니다.");
              return;
            }
            const currencyAddress = currencyById(2); //currencyById(item.currencyId);
            setPageLoading(true);

            const nftAddress = item.nftAddress; // from collectionAssets table
            const tokenId = item.tokenId; // from collectionAssets table
            const price = ethers.utils.parseUnits(inputPrice, 18);

            console.log(`
              [SELL]
              nftAddress = ${nftAddress},
              tokenId = ${tokenId},
              price = ${price}
              `);

            if (escrowCheckbox) {
              // save it before start selling
              const sellerAddress = (await signer.getAddress()).toLowerCase();
              const isEscrow = escrowCheckbox["checked"];
              const response = await apiClient.post(
                "market/sale/startEscrowSale",
                {
                  nftAddress,
                  tokenId,
                  sellerAddress,
                  isEscrow,
                }
              );
              console.log(response);
            }
console.log(currencyAddress+"판매 시작전");
            const tx = await saleContract.startSale(
              nftAddress,
              tokenId,
              1,
              price,
              currencyAddress
            );
		  console.log("판매 시도 후");
            const receipt = await tx.wait();
            console.log(receipt);

            const response = await apiClient.post("blockchain/updateNft");
            if (response.data.result === "ok") {
              setTimeout(() => {
                refreshPage();
                setForceRefresh((prev) => !prev);
                setPageLoading(false);
                setModalIsOpen(false);
                alert("판매에 성공했습니다.");
              }, 10000);
            }
          }
        } catch (e) {
          alert(`왜 발생하는 거지? mobile env debugging, error = ${e}`);
        }
      }}
      onClickClose={function () {}}
    />
  );
};

export { SellModal };
